export default function vhFix() {
    // Select DOM elements
    const headerElement = document.querySelector('header[role="banner"]');
    const footerElement = document.querySelector('footer');
    const supplementalPanel = document.querySelector('header .supplemental-panel');
    const modalMobileImg = document.querySelector('.cdl-modals.multi-step .modal-inner > img');
    const adminBar = document.querySelector('#wpadminbar');

    // Function to update CSS variables
    const updateCSSVariables = () => {
        // Calculate viewport and element dimensions
        const vhUnit = window.innerHeight * 0.01;
        const viewportWidth = document.documentElement.clientWidth;
        const headerHeight = headerElement?.offsetHeight || 0;
        const footerHeight = footerElement?.offsetHeight || 0;
        const adminBarHeight = adminBar?.getBoundingClientRect().height || 0;
        const panelHeight = supplementalPanel?.getBoundingClientRect().height || 0;
        const modalImgHeight = modalMobileImg?.getBoundingClientRect().height || 0;

        // Update CSS variables
        document.documentElement.style.setProperty('--vh', `${vhUnit}px`);
        document.documentElement.style.setProperty('--ww', `${viewportWidth}px`);
        document.documentElement.style.setProperty('--hh', `${headerHeight}px`);
        document.documentElement.style.setProperty('--fh', `${footerHeight}px`);
        document.documentElement.style.setProperty('--sp-height', `${panelHeight}px`);
        document.documentElement.style.setProperty('--modal-image-height', `${modalImgHeight}px`);
        document.documentElement.style.setProperty('--wp-admin--admin-bar--height', `${adminBarHeight}px`);
    };

    // Initial setup
    updateCSSVariables();

    // Update CSS variables after a short delay (handles potential rendering delays)
    setTimeout(updateCSSVariables, 100);

    // Debounced resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateCSSVariables, 10);
    });
}
